import React, { use, useEffect, useState } from "react";
import AvaibilityCalendar from "../../../../components/admin/usable/AvaibilityCalendar";
import { roombyHotel } from "../../../../api/admin/room";
import { useParams } from "react-router";

const AvailableHotel = () => {
  const { id } = useParams();
  const [Rooms, setRooms] = useState([]);
  const [RoomInfo, setRoomInfo] = useState(null);
  useEffect(() => {
    roombyHotel(setRooms, id);
  }, [id]);
  useEffect(() => {
    if (Rooms.length > 0) {
      setRoomInfo(Rooms[0]);
    }
  }, [Rooms]);
  const handleRoomChange = (room) => {
    setRoomInfo({ ...room });
  };
  return (
    <div className="flex gap-4">
      <div className="w-1/3 bg-white rounded-lg p-4 space-y-3">
        <div>
          <p className="text-lg font-semibold">Hotel Rooms</p>
        </div>
        <div>
          {Rooms.map((room) => {
            return (
              <div key={room.id} className=" py-2">
                <button
                  className="px-4 py-1 w-full rounded-lg text-nowrap bg-[#5b5d69] hover:bg-[#233181] text-white"
                  onClick={() => handleRoomChange(room)}
                >
                  {room.roomName}
                </button>
              </div>
            );
          })}
        </div>
      </div>
      <div className="flex-1">
        <AvaibilityCalendar RoomInfo={RoomInfo} />
      </div>
    </div>
  );
};

export default AvailableHotel;
